import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBOVendorRequest.PaymentsSection', {
    payments: 'Payments',
    acctNum: 'Account no.',
    acctNumPlaceholder: "Enter account's name or number",
    specifyPaymentsDetails: 'Specify payment details',
    bankAccountName: 'Bank account name',
    bankAccountNamePlaceholder: 'Enter the name of the bank account',
    bsb: 'BSB',
    bsbPlaceholder: 'Bank identification number used to identify the Bank Branch',
    bankAccountNumber: 'Bank account number',
    bankAccountNumberPlaceholder: 'Enter the bank account number',
    statement: 'Statement text',
    statementPlaceholder: 'Enter any note for remittance',
});
